import { cn } from '../lib/utils';

import type React from 'react';

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-border/20', className)} {...props} />;
}

export { Skeleton };
